import { clearAccountStatus } from './accountStatus'
import { deleteCookie } from './cookie'

export const isUnauthorizedSession = (code?: number, message?: string): boolean =>
  code === 1102 || message?.toLowerCase() === 'unauthorized'

export const clearAuthSessionAndRedirectToLogin = () => {
  deleteCookie('userId')
  deleteCookie('svrId')
  deleteCookie('session_id')
  clearAccountStatus()

  if (window.location.pathname !== '/login') {
    window.location.replace('/login')
  }
}
